import { getField, updateField } from 'vuex-map-fields';
import projectService from './project.service';

const project = {
	namespaced: true,
	state: {
		projects: [],
		projectDetail: {},
		isSearchingProjects: false,
		setIsSavingProject: false,
	},
	getters: {
		getField,
	},
	actions: {
		async getAllProjects({ commit, dispatch }) {
			commit('setIsSearchingProjects', true);
			try {
				const result = await projectService.getAllProjects();
				commit('setProjects', result.data);
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSearchingProjects', false);
		},
		async getProjectById({ commit, dispatch }, id) {
			commit('setIsSearchingProjects', true);
			try {
				const result = await projectService.getProjectById(id);
				commit('setProjectDetails', result.data);
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSearchingProjects', false);
		},
		async saveProject({ state, dispatch }) {
			if (state.projectDetail._id !== 'new') {
				await dispatch('updateProject');
			} else {
				await dispatch('createProject');
			}
		},
		async createProject({ state, dispatch, commit }) {
			commit('setIsSavingProject', true);
			try {
				const projectToCreate = state.projectDetail;
				delete projectToCreate._id;
				const result = await projectService.createProject(projectToCreate);
				if (result.data) {
					commit('setProjectDetails', result.data);
				}
				dispatch('getAllProjects');
				dispatch('toast/makeToast', { message: 'admin.item-saved' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.message,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSavingProject', false);
		},
		async updateProject({ state, dispatch, commit }) {
			commit('setIsSavingProject', true);
			try {
				const result = await projectService.updateProject(state.projectDetail);
				if (result.data) {
					commit('setProjectDetails', result.data);
				}
				dispatch('getAllProjects');
				dispatch('toast/makeToast', { message: 'admin.item-updated' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.message,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSavingProject', false);
		},
		async deleteProject({ state, dispatch, commit }, projectId) {
			try {
				await projectService.deleteProject(projectId);
				commit('setProjects', Array.of(...state.projects.filter(oldProject => oldProject._id !== projectId)));
				dispatch('toast/makeToast', { message: 'admin.item-removed' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.message,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
		},
		async createEndpoint({ state, dispatch }, endpoint) {
			try {
				await projectService.createEndpoint(state.projectDetail._id, endpoint);
				dispatch('getProjectById', state.projectDetail._id);
				dispatch('toast/makeToast', { message: 'admin.item-created' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.message,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
		},
		async updateEndpoint({ state, dispatch }, endpoint) {
			try {
				await projectService.updateEndpoint(state.projectDetail._id, endpoint);
				dispatch('getProjectById', state.projectDetail._id);
				dispatch('toast/makeToast', { message: 'admin.item-updated' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.message,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
		},
		async deleteEndpoint({ state, dispatch }, endpoint) {
			try {
				await projectService.deleteEndpoint(state.projectDetail._id, endpoint);
				dispatch('getProjectById', state.projectDetail._id);
				dispatch('toast/makeToast', { message: 'admin.item-removed' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.message,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
		},
		setNewProject({ commit }) {
			commit('setNewProject');
		},
	},
	mutations: {
		updateField,
		setProjects(state, projects) {
			state.projects = projects;
		},
		setProjectDetails(state, projectDetail) {
			state.projectDetail = projectDetail;
		},
		setIsSearchingProjects(state, searchState) {
			state.isSearchingProjects = searchState;
		},
		setIsSavingProject(state, saveState) {
			state.isSavingProject = saveState;
		},
		setNewProject(state) {
			state.projectDetail = {
				_id: 'new',
				name: ''
			};
		},
	},
};

export default project;
